"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RollIndicator = void 0;
exports.view = view;
const unit_1 = require("../../unit");
const mithril_1 = require("../mithril");
exports.RollIndicator = { view };
function view(dc, ctx) {
    const radius = ctx.height * ctx.zoomLevel / 2;
    const rectWidth = ctx.width * ctx.zoomLevel; // Full width
    // Use pythagorean theorem to get the height offset where the circle's
    // edge will touch the top of the image (which is to be offsetted/scaled later).
    const rectHeight = radius - Math.sqrt((radius * radius) - (rectWidth / 2 * rectWidth / 2));
    const centerHeight = ctx.height * ctx.zoomLevel / 2;
    const centerWidth = ctx.width * ctx.zoomLevel / 2;
    const arcDegrees = 96; // Display graduations over an arc this wide
    const graduationDegrees = 5; // The number of degrees between graduations
    const rollDegrees = unit_1.IkeUnit.convert(ctx.roll, unit_1.IkeUnit.DEGREE, unit_1.IkeUnit.RADIAN);
    const rollText = rollDegrees.toFixed(1) + '°';
    let graduations = [];
    for (var i = -180; i <= 180; i += graduationDegrees) {
        graduations.push({ degrees: i });
    }
    // Display the graduations within `arcDegrees` around the `roll` value
    graduations = graduations.filter(grad => Math.abs(grad.degrees - rollDegrees) <= arcDegrees / 2);
    const graduationLength = 25 * ctx.zoomLevel; // The length of each graduation's rendered line
    let indicatorElements = [];
    var degreesElements = [];
    // Arc
    indicatorElements.push((0, mithril_1.m)('path', {
        d: `M 0 ${rectHeight} A ${radius} ${radius} 0 0 1 ${rectWidth} ${rectHeight}`,
        stroke: 'white',
        'stroke-width': '8px',
        'fill-opacity': '0'
    }));
    //degree text
    degreesElements.push((0, mithril_1.m)('text', {
        x: centerWidth,
        y: centerHeight,
        transform: `translate(0, ${-radius + graduationLength + (65 * ctx.zoomLevel)})`,
        fill: 'white',
        'font-size': `${60 * ctx.zoomLevel}px`,
        'text-anchor': 'middle'
    }, rollText));
    //roll arrow tick left
    degreesElements.push((0, mithril_1.m)('path', {
        d: `M ${centerWidth} ${centerHeight - radius} l ${graduationLength} 0`,
        stroke: 'white',
        'stroke-width': 8 + 'px',
        transform: 'rotate(45)',
        'transform-origin': `${centerWidth} ${centerHeight - radius}`
    }));
    //roll arrow tick right
    degreesElements.push((0, mithril_1.m)('path', {
        d: `M ${centerWidth} ${centerHeight - radius} l ${graduationLength} 0`,
        stroke: 'white',
        'stroke-width': 8 + 'px',
        transform: 'rotate(135)',
        'transform-origin': `${centerWidth} ${centerHeight - radius}`
    }));
    indicatorElements.push((0, mithril_1.m)('g', degreesElements));
    indicatorElements.push(...graduations.map(grad => (0, mithril_1.m)('g', [
        // Graduation degree label
        (0, mithril_1.m)('g', {
            transform: `rotate(${grad.degrees - rollDegrees})`,
            'transform-origin': `${centerWidth} ${centerHeight}`
        }, (0, mithril_1.m)('text', {
            x: centerWidth,
            y: centerHeight,
            transform: `translate(0, ${-radius - 13})`,
            fill: 'white',
            'font-size': `${50 * ctx.zoomLevel}px`,
            'text-anchor': 'middle'
        }, `${grad.degrees}`)),
        // Graduation line
        (0, mithril_1.m)('path', {
            d: `M ${centerWidth} ${centerHeight} l ${graduationLength} 0`,
            stroke: 'white',
            'stroke-width': Math.round(8 * ctx.zoomLevel) + 'px',
            transform: `rotate(${grad.degrees - 90 - rollDegrees}) translate(${radius - graduationLength})`,
            'transform-origin': `${centerWidth} ${centerHeight}`
        })
    ])));
    return (0, mithril_1.m)('g', {
        className: 'c-Draw-rollindicator',
        transform: `scale(${ctx.scale / 4}) translate(0, ${(ctx.resHeight * 0.05) * ctx.zoomLevel})`,
        filter: 'drop-shadow(0 0 10px black)',
        'pointer-events': 'none'
    }, indicatorElements);
}
//# sourceMappingURL=rollIndicator.js.map